import React from 'react'
import type { FC } from 'react'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import type { User } from '@homeviews/models'

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      marginTop: 25,
      '& .l-labelFieldWrapper': {
        width: `152px!important`,
        fontWeight: 500,
      },
      '& .l-fieldWrapper--horizontal': {
        width: `152px!important`,
        boxShadow: 'none!important',
        padding: `0!important`,
        marginBottom: 25,
      },
    },
  }),
)

const UserSummary: FC<Partial<User>> = ({
  first_name,
  last_name,
  email,
  job_title,
}) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <div className="l-fieldWrapper l-fieldWrapper--horizontal">
        <div className="l-labelFieldWrapper">
          <label>First name</label>
        </div>
        {first_name}
      </div>
      <div className="l-fieldWrapper l-fieldWrapper--horizontal">
        <div className="l-labelFieldWrapper">
          <label>Surname</label>
        </div>
        {last_name}
      </div>
      <div className="l-fieldWrapper l-fieldWrapper--horizontal">
        <div className="l-labelFieldWrapper">
          <label>Email</label>
        </div>
        {email}
      </div>
      <div className="l-fieldWrapper l-fieldWrapper--horizontal">
        <div className="l-labelFieldWrapper">
          <label>Job Title</label>
        </div>
        {job_title}
      </div>
    </div>
  )
}

export default UserSummary
